import React from 'react';
import './Loader.css';

const Loader = ({ text = "Loading...", fullScreen = false }) => {
  return (
    <div className={`loader-container ${fullScreen ? 'fullscreen-loader' : 'inline-loader'}`}>
      <div className="custom-spinner">
        <div className="spinner-circle"></div>
      </div>
      {text && <p className="loader-text mt-3 text-muted">{text}</p>}
    </div>
  );
};

export default Loader;
